import React from 'react';
import { TrendingUp, BubbleChart, BarChart, Timelapse, Settings, SupervisorAccount, Home } from '@material-ui/icons';
import sideBarMenuVector from '../assets/images/sideBarMenuVector.svg';
import sideBarMenuVectorLarge from '../assets/images/sideBarMenuVectorLarge.svg';
import RankingFactorIcon from '../assets/images/ranking-factors-icon.png';
import RankingFactorLargeIcon from '../assets/images/ranking-factors-icon-large.png';
import iconHelpCenter from '../assets/images/iconHelpCenter.svg';
import manageEntities from '../assets/images/manageEntities.svg';
import optimizeContent from '../assets/images/optimizeContent.svg';
import optimizeContentLarge from '../assets/images/optimizeContentLarge.svg';
import InternalLinkingAI from '../assets/images/InternalLinkingAI.svg';
import InternalLinkingAILarge from '../assets/images/InternalLinkingAILarge.svg';
import AddNewLink from '../components/discoverability/internalLinkingRecommendations/AddNewLink';
import CreateContentBrief from '../components/content-recommendations/Content-Brief/CreateContentBrief';
import { CONTENT_AI_ONLY_SCHEMAS } from '../config/auth';

export interface SidebarNav {
  title: string;
  icon?: React.ReactElement;
  iconLarge?: React.ReactElement;
  isDynamicNav?: boolean;
  isSection?: boolean;
  isSubscriberUserShow?: boolean;
  isInternal?: boolean;
  key?: string;
  parentTitle?: string | React.ReactElement;
  uniqueKey?: string;
  parentSectionKey?: string;
  subNavs?: SidebarNav[];
  to?: string;
  toExternal?: string;
  display?: boolean;
  isShow?: boolean;
  showCreateNewUrlButton?: boolean;
  customComponent?: HTMLElement | any | unknown;
  IsPlaneNav?: boolean;
  selectBox?: boolean;
  isTools?: boolean;
  isAtBottom?: boolean;
  showNewBadge?: boolean;
}

export const selectionToggleForEnterpriseUser: SidebarNav = {
  title: '',
  key: 'user-type-selection',
  isSection: false,
  isSubscriberUserShow: false,
  uniqueKey: 'user-type-selection',
  IsPlaneNav: true,
  subNavs: [],
  selectBox: true,
};

export const aiToolsNavConfig: SidebarNav[] = [
  {
    title: 'Home',
    icon: <Home />,
    iconLarge: <Home />,
    key: 'home',
    isSection: false,
    to: '/app/ai-tools-home',
    isSubscriberUserShow: false,
    uniqueKey: 'ai_tools_home',
    IsPlaneNav: true,
    subNavs: [],
  },
  {
    title: 'AI SEO Tools',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.25 2.775C1.29731 2.775 0.525 3.54731 0.525 4.5V19.2C0.525 20.1527 1.29731 20.925 2.25 20.925H21.75C22.7027 20.925 23.475 20.1527 23.475 19.2V4.5C23.475 3.54731 22.7027 2.775 21.75 2.775H2.25ZM0 4.5C0 3.25736 1.00736 2.25 2.25 2.25H21.75C22.9926 2.25 24 3.25736 24 4.5V19.2C24 20.4426 22.9926 21.45 21.75 21.45H2.25C1.00736 21.45 0 20.4426 0 19.2V4.5Z"
          fill="#1D3557"
        />
        <path
          d="M2.92539 5.2502C3.21534 5.2502 3.45039 5.01514 3.45039 4.7252C3.45039 4.43525 3.21534 4.2002 2.92539 4.2002C2.63544 4.2002 2.40039 4.43525 2.40039 4.7252C2.40039 5.01514 2.63544 5.2502 2.92539 5.2502Z"
          fill="#1D3557"
        />
        <path
          d="M5.1002 5.2502C5.39014 5.2502 5.6252 5.01514 5.6252 4.7252C5.6252 4.43525 5.39014 4.2002 5.1002 4.2002C4.81025 4.2002 4.5752 4.43525 4.5752 4.7252C4.5752 5.01514 4.81025 5.2502 5.1002 5.2502Z"
          fill="#1D3557"
        />
        <path
          d="M7.275 5.2502C7.56495 5.2502 7.8 5.01514 7.8 4.7252C7.8 4.43525 7.56495 4.2002 7.275 4.2002C6.98505 4.2002 6.75 4.43525 6.75 4.7252C6.75 5.01514 6.98505 5.2502 7.275 5.2502Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.9248 4.72539C11.9248 4.58042 12.0423 4.46289 12.1873 4.46289H21.3373C21.4823 4.46289 21.5998 4.58042 21.5998 4.72539C21.5998 4.87037 21.4823 4.98789 21.3373 4.98789H12.1873C12.0423 4.98789 11.9248 4.87037 11.9248 4.72539Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.4375 16.4246C2.4375 16.2796 2.55503 16.1621 2.7 16.1621H21.375C21.52 16.1621 21.6375 16.2796 21.6375 16.4246C21.6375 16.5696 21.52 16.6871 21.375 16.6871H2.7C2.55503 16.6871 2.4375 16.5696 2.4375 16.4246Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.4375 18.7498C2.4375 18.6048 2.55503 18.4873 2.7 18.4873H12.75C12.895 18.4873 13.0125 18.6048 13.0125 18.7498C13.0125 18.8948 12.895 19.0123 12.75 19.0123H2.7C2.55503 19.0123 2.4375 18.8948 2.4375 18.7498Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.56426 8.98736C5.69562 9.11961 5.69489 9.3333 5.56264 9.46465L3.18058 11.8306L5.56081 14.1589C5.69406 14.2893 5.69641 14.503 5.56607 14.6362C5.43573 14.7694 5.22205 14.7718 5.0888 14.6415L2.4638 12.0737C2.39921 12.0105 2.36265 11.9241 2.36231 11.8337C2.36196 11.7434 2.39786 11.6566 2.46197 11.593L5.08697 8.98574C5.21922 8.85438 5.43291 8.85511 5.56426 8.98736Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.83535 8.98736C8.9667 8.85511 9.18039 8.85438 9.31264 8.98574L11.9376 11.593C12.0017 11.6566 12.0376 11.7434 12.0373 11.8337C12.037 11.9241 12.0004 12.0105 11.9358 12.0737L9.31081 14.6415C9.17756 14.7718 8.96388 14.7694 8.83354 14.6362C8.7032 14.503 8.70555 14.2893 8.8388 14.1589L11.219 11.8306L8.83697 9.46465C8.70472 9.3333 8.70399 9.11961 8.83535 8.98736Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.29563 8.839C8.47014 8.9045 8.5585 9.09907 8.493 9.27358L6.50903 14.5591C6.44353 14.7336 6.24896 14.8219 6.07446 14.7564C5.89995 14.6909 5.81158 14.4964 5.87709 14.3219L7.86105 9.03637C7.92656 8.86186 8.12112 8.7735 8.29563 8.839Z"
          fill="#1D3557"
        />
      </svg>
    ),
    key: 'ai_seo_tools',
    isSection: false,
    isSubscriberUserShow: true,
    isTools: true,
    uniqueKey: 'ai_seo_tools',
    parentSectionKey: 'all_tools',
    subNavs: [
      {
        title: 'Title Generator',
        parentTitle: 'AI SEO Tools',
        uniqueKey: 'title_generator',
        icon: <TrendingUp />,
        to: '/free-tools/title-generator',
        isShow: true,
      },
      {
        title: 'H1 Heading Generator',
        parentTitle: 'AI SEO Tools',
        uniqueKey: 'h1_heading_generator',
        icon: <TrendingUp />,
        to: '/free-tools/heading-generator',
        isShow: true,
      },
      {
        title: 'SEO-Friendly URL Generator',
        parentTitle: 'AI SEO Tools',
        uniqueKey: 'seo_friendly_url_generator',
        icon: <TrendingUp />,
        to: '/free-tools/seo-url-generator',
        isShow: true,
      },
      {
        title: 'Meta Description Generator',
        parentTitle: 'AI SEO Tools',
        uniqueKey: 'meta_description_generator',
        icon: <TrendingUp />,
        to: '/free-tools/meta-description-generator',
        isShow: true,
      },
    ],
  },

  {
    title: 'AI Content Writing Tools',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.0371094 4.04961C0.0371094 2.662 1.162 1.53711 2.54961 1.53711H21.4496C22.8373 1.53711 23.9621 2.662 23.9621 4.04961V18.2246C23.9621 19.6123 22.8373 20.7371 21.4496 20.7371H17.7034C17.5584 20.7371 17.4409 20.6196 17.4409 20.4746C17.4409 20.3296 17.5584 20.2121 17.7034 20.2121H21.4496C22.5473 20.2121 23.4371 19.3223 23.4371 18.2246V4.04961C23.4371 2.95194 22.5473 2.06211 21.4496 2.06211H2.54961C1.45195 2.06211 0.562109 2.95195 0.562109 4.04961V18.2246C0.562109 19.3223 1.45194 20.2121 2.54961 20.2121H15.2246C15.3696 20.2121 15.4871 20.3296 15.4871 20.4746C15.4871 20.6196 15.3696 20.7371 15.2246 20.7371H2.54961C1.162 20.7371 0.0371094 19.6123 0.0371094 18.2246V4.04961Z"
          fill="#1D3557"
        />
        <path
          d="M2.92539 4.64961C3.21534 4.64961 3.45039 4.41456 3.45039 4.12461C3.45039 3.83466 3.21534 3.59961 2.92539 3.59961C2.63544 3.59961 2.40039 3.83466 2.40039 4.12461C2.40039 4.41456 2.63544 4.64961 2.92539 4.64961Z"
          fill="#1D3557"
        />
        <path
          d="M5.1002 4.64961C5.39014 4.64961 5.6252 4.41456 5.6252 4.12461C5.6252 3.83466 5.39014 3.59961 5.1002 3.59961C4.81025 3.59961 4.5752 3.83466 4.5752 4.12461C4.5752 4.41456 4.81025 4.64961 5.1002 4.64961Z"
          fill="#1D3557"
        />
        <path
          d="M7.275 4.64961C7.56495 4.64961 7.8 4.41456 7.8 4.12461C7.8 3.83466 7.56495 3.59961 7.275 3.59961C6.98505 3.59961 6.75 3.83466 6.75 4.12461C6.75 4.41456 6.98505 4.64961 7.275 4.64961Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.9248 4.1248C11.9248 3.97983 12.0423 3.8623 12.1873 3.8623H21.3373C21.4823 3.8623 21.5998 3.97983 21.5998 4.1248C21.5998 4.26978 21.4823 4.3873 21.3373 4.3873H12.1873C12.0423 4.3873 11.9248 4.26978 11.9248 4.1248Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.3623 9.7498C2.3623 9.60483 2.47983 9.4873 2.6248 9.4873H21.3748C21.5198 9.4873 21.6373 9.60483 21.6373 9.7498C21.6373 9.89478 21.5198 10.0123 21.3748 10.0123H2.6248C2.47983 10.0123 2.3623 9.89478 2.3623 9.7498Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.3623 12.2254C2.3623 12.0804 2.47983 11.9629 2.6248 11.9629H16.6498C16.7948 11.9629 16.9123 12.0804 16.9123 12.2254C16.9123 12.3704 16.7948 12.4879 16.6498 12.4879H2.6248C2.47983 12.4879 2.3623 12.3704 2.3623 12.2254Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.3623 14.7C2.3623 14.555 2.47983 14.4375 2.6248 14.4375H11.7748C11.9198 14.4375 12.0373 14.555 12.0373 14.7C12.0373 14.845 11.9198 14.9625 11.7748 14.9625H2.6248C2.47983 14.9625 2.3623 14.845 2.3623 14.7Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.3623 17.1746C2.3623 17.0296 2.47983 16.9121 2.6248 16.9121H11.7748C11.9198 16.9121 12.0373 17.0296 12.0373 17.1746C12.0373 17.3196 11.9198 17.4371 11.7748 17.4371H2.6248C2.47983 17.4371 2.3623 17.3196 2.3623 17.1746Z"
          fill="#1D3557"
        />
        <path d="M19.6105 12.75L15.375 19.2512L17.5882 21L21.9 14.2328L19.6105 12.75Z" fill="#1D3557" />
        <path
          d="M22.1515 13.7997L19.875 12.3191L20.3169 11.5763C20.5954 11.1082 21.2033 10.959 21.6668 11.245L22.2999 11.6356C22.7465 11.9111 22.8949 12.4906 22.6358 12.9468L22.1515 13.7997Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.6805 19.6357L15.3852 21.5325L17.1146 20.863L16.3891 20.242L15.6805 19.6357ZM15.341 19.3786C15.3726 19.1753 15.615 19.0861 15.771 19.2195L16.6329 19.9571L17.5015 20.7005C17.5015 20.7005 17.5015 20.7005 17.5015 20.7005C17.6523 20.8295 17.611 21.073 17.4256 21.1447M17.4256 21.1447L15.3389 21.9526C15.3389 21.9526 15.3389 21.9525 15.3389 21.9526C15.1503 22.0256 14.9537 21.867 14.9847 21.6674L15.341 19.3787C15.341 19.3787 15.341 19.3787 15.341 19.3786C15.341 19.3786 15.341 19.3786 15.341 19.3786"
          fill="#1D3557"
        />
        <path
          d="M15.1647 21.7801L15.2815 20.8451C15.2891 20.7844 15.3621 20.7579 15.407 20.7994L15.7497 21.1176L16.1082 21.4505C16.1496 21.489 16.1352 21.5577 16.0818 21.5763L15.2637 21.8603C15.2112 21.8785 15.1578 21.8352 15.1647 21.7801Z"
          fill="#1D3557"
        />
      </svg>
    ),
    key: 'ai_content_writing_tools',
    isSection: false,
    isTools: true,
    isSubscriberUserShow: true,
    uniqueKey: 'ai_content_writing_tools',
    parentSectionKey: 'all_tools',
    subNavs: [
      {
        title: 'Paragraph Generator',
        parentTitle: 'AI Content Writing Tools',
        uniqueKey: 'paragraph_generator',
        icon: <TrendingUp />,
        to: '/free-tools/paragraph-generator',
        isShow: true,
      },
      {
        title: 'Paragraph Rewriter',
        parentTitle: 'AI Content Writing Tools',
        uniqueKey: 'paragraph_rewriter',
        icon: <TrendingUp />,
        to: '/free-tools/ai-rewriter',
        isShow: true,
      },
      {
        title: 'Content Brief Generator',
        parentTitle: 'AI Content Writing Tools',
        uniqueKey: 'content_brief_generator',
        icon: <TrendingUp />,
        to: '/free-tools/content-brief-generator',
        isShow: true,
      },
      {
        title: 'Paraphraser',
        parentTitle: 'AI Content Writing Tools',
        uniqueKey: 'paraphraser',
        icon: <TrendingUp />,
        to: '/free-tools/paraphraser',
        isShow: true,
      },
      {
        title: 'Summary Generator',
        parentTitle: 'AI Content Writing Tools',
        uniqueKey: 'summary_generator',
        icon: <TrendingUp />,
        to: '/free-tools/summary-generator',
        isShow: true,
      },
      {
        title: 'Active-Passive Converter',
        parentTitle: 'AI Content Writing Tools',
        uniqueKey: 'active_passive_converter',
        icon: <TrendingUp />,
        to: '/free-tools/active-passive-changer',
        isShow: true,
      },
      {
        title: 'Step-wise Instructions Generator',
        parentTitle: 'AI Content Writing Tools',
        uniqueKey: 'step_wise_instructions_generator',
        icon: <TrendingUp />,
        to: '/free-tools/step-wise-instructions',
        isShow: true,
      },
      {
        title: 'AI Text Generator',
        parentTitle: 'AI Content Writing Tools',
        uniqueKey: 'ai_text_generator',
        icon: <TrendingUp />,
        to: '/free-tools/ai-text-generator',
        isShow: true,
      },
    ],
  },

  {
    title: 'AI Content Optimization Tools',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.25 2.525C1.29731 2.525 0.525 3.29731 0.525 4.25V18.95C0.525 19.9027 1.29731 20.675 2.25 20.675H21.75C22.7027 20.675 23.475 19.9027 23.475 18.95V4.25C23.475 3.29731 22.7027 2.525 21.75 2.525H2.25ZM0 4.25C0 3.00736 1.00736 2 2.25 2H21.75C22.9926 2 24 3.00736 24 4.25V18.95C24 20.1926 22.9926 21.2 21.75 21.2H2.25C1.00736 21.2 0 20.1926 0 18.95V4.25Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.9248 4.47539C11.9248 4.33042 12.0423 4.21289 12.1873 4.21289H21.3373C21.4823 4.21289 21.5998 4.33042 21.5998 4.47539C21.5998 4.62037 21.4823 4.73789 21.3373 4.73789H12.1873C12.0423 4.73789 11.9248 4.62037 11.9248 4.47539Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.4498 17.0371C18.5947 17.037 18.7124 17.1544 18.7125 17.2994L18.7163 21.3371C18.7165 21.4821 18.599 21.5997 18.4541 21.5999C18.3091 21.6 18.1915 21.4826 18.1913 21.3376L18.1875 17.2999C18.1874 17.1549 18.3048 17.0372 18.4498 17.0371Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.4321 17.4538L17.3656 18.5843C17.2661 18.6898 17.0999 18.6946 16.9945 18.5951C16.889 18.4956 16.8842 18.3295 16.9837 18.2241L18.0662 17.0766C18.2618 16.8693 18.5907 16.8659 18.7904 17.0694L19.9196 18.2204C20.0211 18.3238 20.0195 18.49 19.916 18.5916C19.8125 18.6931 19.6463 18.6915 19.5448 18.588L18.4321 17.4538Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.3623 8.825C2.3623 8.68003 2.47983 8.5625 2.6248 8.5625H21.2998C21.4448 8.5625 21.5623 8.68003 21.5623 8.825C21.5623 8.96998 21.4448 9.0875 21.2998 9.0875H2.6248C2.47983 9.0875 2.3623 8.96998 2.3623 8.825Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.3623 12.575C2.3623 12.43 2.47983 12.3125 2.6248 12.3125H13.8748C14.0198 12.3125 14.1373 12.43 14.1373 12.575C14.1373 12.72 14.0198 12.8375 13.8748 12.8375H2.6248C2.47983 12.8375 2.3623 12.72 2.3623 12.575Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.3623 16.325C2.3623 16.18 2.47983 16.0625 2.6248 16.0625H11.8498C11.9948 16.0625 12.1123 16.18 12.1123 16.325C12.1123 16.47 11.9948 16.5875 11.8498 16.5875H2.6248C2.47983 16.5875 2.3623 16.47 2.3623 16.325Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.7996 7.5127C16.9446 7.5127 17.0621 7.63022 17.0621 7.7752V9.8752C17.0621 10.0202 16.9446 10.1377 16.7996 10.1377C16.6546 10.1377 16.5371 10.0202 16.5371 9.8752V7.7752C16.5371 7.63022 16.6546 7.5127 16.7996 7.5127Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.2752 11.2627C7.42017 11.2627 7.53769 11.3802 7.53769 11.5252V13.6252C7.53769 13.7702 7.42017 13.8877 7.2752 13.8877C7.13022 13.8877 7.0127 13.7702 7.0127 13.6252V11.5252C7.0127 11.3802 7.13022 11.2627 7.2752 11.2627Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.2752 15.0127C7.42017 15.0127 7.53769 15.1302 7.53769 15.2752V17.3752C7.53769 17.5202 7.42017 17.6377 7.2752 17.6377C7.13022 17.6377 7.0127 17.5202 7.0127 17.3752V15.2752C7.0127 15.1302 7.13022 15.0127 7.2752 15.0127Z"
          fill="#1D3557"
        />
        <path
          d="M2.92539 5.0002C3.21534 5.0002 3.45039 4.76514 3.45039 4.4752C3.45039 4.18525 3.21534 3.9502 2.92539 3.9502C2.63544 3.9502 2.40039 4.18525 2.40039 4.4752C2.40039 4.76514 2.63544 5.0002 2.92539 5.0002Z"
          fill="#1D3557"
        />
        <path
          d="M5.1002 5.0002C5.39014 5.0002 5.6252 4.76514 5.6252 4.4752C5.6252 4.18525 5.39014 3.9502 5.1002 3.9502C4.81025 3.9502 4.5752 4.18525 4.5752 4.4752C4.5752 4.76514 4.81025 5.0002 5.1002 5.0002Z"
          fill="#1D3557"
        />
        <path
          d="M7.275 5.0002C7.56495 5.0002 7.8 4.76514 7.8 4.4752C7.8 4.18525 7.56495 3.9502 7.275 3.9502C6.98505 3.9502 6.75 4.18525 6.75 4.4752C6.75 4.76514 6.98505 5.0002 7.275 5.0002Z"
          fill="#1D3557"
        />
        <path
          d="M17.1946 22.3639C19.6078 22.3639 21.5641 20.4076 21.5641 17.9944C21.5641 15.5813 19.6078 13.625 17.1946 13.625C14.7815 13.625 12.8252 15.5813 12.8252 17.9944C12.8252 20.4076 14.7815 22.3639 17.1946 22.3639Z"
          fill="#1D3557"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.1551 15.2695C17.3 15.269 17.418 15.3861 17.4186 15.531L17.4381 20.7018C17.4386 20.8468 17.3215 20.9648 17.1765 20.9653C17.0316 20.9659 16.9136 20.8488 16.9131 20.7038L16.8936 15.533C16.893 15.388 17.0101 15.2701 17.1551 15.2695Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.1472 15.5787L15.7161 17.0956C15.6167 17.201 15.4505 17.2059 15.3451 17.1064C15.2396 17.0069 15.2348 16.8408 15.3343 16.7353L16.8457 15.1332C17.0062 14.9632 17.2761 14.9603 17.44 15.1275C17.4401 15.1275 17.4401 15.1276 17.4401 15.1276L19.0139 16.7316C19.1155 16.8351 19.1139 17.0013 19.0104 17.1028C18.9069 17.2044 18.7407 17.2028 18.6392 17.0993L17.1472 15.5787Z"
          fill="white"
        />
      </svg>
    ),
    key: 'ai_content_optimization_tools',
    isSection: false,
    isSubscriberUserShow: true,
    isTools: true,
    uniqueKey: 'ai_content_optimization_tools',
    parentSectionKey: 'all_tools',
    subNavs: [
      {
        title: 'Heading Rewriter',
        parentTitle: 'AI Content Optimization Tools',
        uniqueKey: 'heading_rewriter',
        icon: <TrendingUp />,
        to: '/free-tools/heading-rewriter',
        isShow: true,
      },
      {
        title: 'Discover Topics',
        parentTitle: 'AI Content Optimization Tools',
        uniqueKey: 'discover_topics',
        icon: <TrendingUp />,
        to: '/free-tools/topic-discovery',
        isShow: true,
      },
      {
        title: 'Image Alt Text Generator',
        parentTitle: 'AI Content Optimization Tools',
        uniqueKey: 'image_alt_text_generator',
        icon: <TrendingUp />,
        to: '/free-tools/image-alt-text-generator',
        isShow: true,
      },
      {
        title: 'Anchor Text Generator',
        parentTitle: 'AI Content Optimization Tools',
        uniqueKey: 'anchor_text_generator',
        icon: <TrendingUp />,
        to: '/free-tools/anchor-text-generator',
        isShow: true,
      },
    ],
  },

  {
    title: 'AI Keyword Research Tools',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_4592_185992)">
          <path
            d="M16.9197 9.90747C17.1105 10.0749 17.2939 10.2469 17.4749 10.4249C17.5455 10.494 17.5455 10.494 17.6176 10.5646C18.7267 11.7391 19.0152 13.2048 18.9954 14.7664C18.968 15.652 18.7032 16.3756 18.2396 17.1218C18.1268 17.3137 18.1268 17.3137 18.2032 17.4704C18.3072 17.6366 18.4188 17.7617 18.5579 17.8999C18.6105 17.9524 18.663 18.0049 18.7171 18.0591C18.7738 18.1149 18.8304 18.1708 18.8888 18.2284C18.9468 18.2862 19.0049 18.3441 19.0647 18.4036C19.25 18.5882 19.4359 18.7721 19.6218 18.9561C19.7476 19.0812 19.8734 19.2063 19.9991 19.3314C20.3073 19.6379 20.616 19.9441 20.9249 20.2499C20.753 20.7109 20.4547 20.9677 20.0999 21.2999C20.0502 21.3481 20.0005 21.3963 19.9493 21.446C19.814 21.5717 19.814 21.5717 19.5749 21.7499C19.3101 21.7307 19.1843 21.6103 19.0047 21.4242C18.9531 21.3714 18.9015 21.3186 18.8484 21.2642C18.7935 21.2069 18.7385 21.1497 18.6819 21.0907C18.5647 20.9709 18.4474 20.8512 18.3301 20.7315C18.1456 20.5419 17.9614 20.3519 17.7776 20.1616C17.6002 19.9783 17.4216 19.7962 17.2429 19.6141C17.188 19.5565 17.133 19.499 17.0764 19.4397C17.0249 19.3873 16.9733 19.335 16.9202 19.2811C16.8751 19.2345 16.8301 19.188 16.7836 19.14C16.6556 19.0328 16.6556 19.0328 16.4983 19.0658C16.3178 19.1377 16.1436 19.2206 15.9695 19.3068C14.6335 19.9647 13.0931 20.1335 11.6539 19.6742C10.8839 19.3731 10.2165 19.0073 9.59992 18.4499C9.54684 18.4029 9.49376 18.3559 9.43908 18.3075C8.4402 17.3716 7.86682 15.9932 7.78204 14.6395C7.73989 13.1053 8.18123 11.6937 9.20499 10.5289C11.2299 8.39569 14.5755 8.01092 16.9197 9.90747ZM10.7642 11.929C10.1149 12.7581 9.82281 13.6484 9.89992 14.6999C10.0789 15.712 10.5563 16.537 11.3765 17.1561C12.2078 17.7078 13.1866 17.8851 14.1617 17.6928C15.0928 17.4271 15.8272 16.9231 16.3572 16.1079C16.8027 15.2974 16.9889 14.4176 16.7964 13.5031C16.4564 12.4177 15.8607 11.6351 14.8499 11.0999C13.4435 10.5073 11.8181 10.7825 10.7642 11.929Z"
            fill="#1D3557"
          />
          <path
            d="M5.87746 -0.0553906C5.99842 -0.0557556 6.11937 -0.0563143 6.24033 -0.05705C6.56621 -0.0584505 6.89203 -0.0570571 7.21791 -0.0550502C7.56022 -0.0533419 7.90253 -0.05397 8.24484 -0.0542622C8.81924 -0.0543943 9.39361 -0.0527404 9.968 -0.0499707C10.6308 -0.0467927 11.2936 -0.04627 11.9565 -0.047205C12.5961 -0.0480608 13.2357 -0.0472104 13.8753 -0.045529C14.1466 -0.0448347 14.418 -0.0446998 14.6894 -0.0450168C15.0091 -0.0453005 15.3287 -0.0440741 15.6484 -0.0417078C15.7653 -0.0410745 15.8822 -0.0409416 15.9991 -0.0413613C17.5723 -0.0461498 18.3485 0.795352 19.4329 1.82682C19.6777 2.05843 19.9291 2.28109 20.1836 2.5019C20.4257 2.71345 20.6611 2.93225 20.8965 3.15135C21.096 3.33604 21.2982 3.50785 21.5156 3.67077C21.9584 4.06541 22.1924 4.57589 22.2417 5.16081C22.2638 5.60769 22.26 6.05448 22.257 6.50176C22.2575 6.67358 22.2582 6.8454 22.2591 7.01722C22.2608 7.48179 22.2597 7.9463 22.258 8.41087C22.2566 8.89798 22.2574 9.3851 22.2579 9.87222C22.2584 10.7422 22.2567 11.6122 22.2541 12.4822C22.2518 13.2699 22.2516 14.0575 22.253 14.8451C22.2549 15.8596 22.2548 16.8741 22.2531 17.8885C22.2525 18.2752 22.2527 18.6618 22.2534 19.0485C22.2542 19.5039 22.2531 19.9593 22.2507 20.4147C22.25 20.5816 22.2501 20.7484 22.2508 20.9152C22.2516 21.1435 22.2502 21.3717 22.2481 21.6001C22.2489 21.6655 22.2497 21.731 22.2505 21.7985C22.2406 22.4016 21.9894 23.0026 21.5734 23.4479C20.7895 24.0992 19.9661 24.0647 19.0002 24.0575C18.8446 24.058 18.689 24.0587 18.5335 24.0595C18.1132 24.0612 17.693 24.0601 17.2728 24.0584C16.8319 24.057 16.391 24.0578 15.9502 24.0583C15.2101 24.0588 14.4701 24.0575 13.7301 24.055C12.8756 24.0522 12.0212 24.0523 11.1668 24.054C10.3431 24.0556 9.51947 24.0551 8.69582 24.0536C8.34601 24.053 7.99622 24.0531 7.64641 24.0539C7.23431 24.0546 6.82226 24.0536 6.41016 24.0511C6.2593 24.0505 6.10843 24.0505 5.95757 24.0512C4.93349 24.0555 4.2268 23.9704 3.45001 23.2505C3.4153 23.2115 3.3806 23.1725 3.34484 23.1324C3.20278 23.0056 3.09966 22.9803 2.91564 22.9364C2.42868 22.7839 2.0482 22.4643 1.76866 22.0384C1.58835 21.6902 1.49089 21.3691 1.48995 20.9754C1.48961 20.9105 1.48928 20.8456 1.48893 20.7788C1.48895 20.7078 1.48896 20.6369 1.48897 20.5638C1.48856 20.4504 1.48856 20.4504 1.48814 20.3346C1.48731 20.0804 1.48702 19.8263 1.48674 19.5721C1.48627 19.3901 1.48577 19.2082 1.48524 19.0262C1.4838 18.4796 1.48301 17.933 1.48234 17.3864C1.48201 17.1288 1.48161 16.8712 1.48121 16.6135C1.47994 15.7567 1.47885 14.8999 1.47831 14.0431C1.47816 13.8209 1.47802 13.5986 1.47787 13.3764C1.47784 13.3211 1.4778 13.2659 1.47776 13.209C1.47714 12.3147 1.47524 11.4205 1.47281 10.5263C1.47032 9.60749 1.46897 8.68869 1.46873 7.76989C1.46857 7.25431 1.46792 6.73874 1.466 6.22316C1.4642 5.73788 1.46394 5.25262 1.46471 4.76735C1.46474 4.58955 1.46427 4.41174 1.46324 4.23395C1.46191 3.99053 1.46245 3.74719 1.46343 3.50378C1.46261 3.43401 1.46179 3.36425 1.46094 3.29237C1.46667 2.70181 1.6055 2.10142 1.96876 1.62233C2.36435 1.24473 2.7633 1.02796 3.29415 0.898113C3.46621 0.832546 3.46621 0.832546 3.58525 0.648725C4.16793 -0.0524485 5.03615 -0.0643696 5.87746 -0.0553906ZM3.92345 1.17702C3.52276 1.69243 3.49227 2.2976 3.49694 2.92643C3.49665 3.00713 3.49635 3.08783 3.49604 3.17098C3.49532 3.44008 3.4962 3.70915 3.49709 3.97826C3.49691 4.17172 3.49663 4.36517 3.49626 4.55863C3.49555 5.02873 3.49604 5.49883 3.49695 5.96893C3.49798 6.51681 3.49785 7.06469 3.49769 7.61258C3.49745 8.59033 3.49833 9.56809 3.4998 10.5458C3.50122 11.4938 3.50175 12.4418 3.50134 13.3898C3.50088 14.4232 3.5009 15.4565 3.50175 16.4898C3.50184 16.6 3.50193 16.7103 3.50202 16.8205C3.50206 16.8748 3.50211 16.929 3.50216 16.9849C3.50245 17.3665 3.50242 17.7481 3.50227 18.1297C3.5021 18.6435 3.50274 19.1573 3.50393 19.6712C3.50425 19.8597 3.50431 20.0482 3.5041 20.2368C3.50386 20.4942 3.50454 20.7516 3.50546 21.009C3.50518 21.0835 3.50489 21.1581 3.5046 21.2349C3.50851 21.8556 3.57419 22.3744 3.97501 22.8755C4.4521 23.3318 4.86545 23.4231 5.51113 23.4205C5.57412 23.4209 5.63712 23.4212 5.70203 23.4215C5.91257 23.4225 6.1231 23.4224 6.33365 23.4222C6.48483 23.4227 6.63602 23.4232 6.78721 23.4238C7.19754 23.4251 7.60787 23.4254 8.01821 23.4255C8.27469 23.4256 8.53116 23.426 8.78763 23.4264C9.6827 23.4278 10.5778 23.4284 11.4728 23.4282C12.3067 23.4282 13.1405 23.4297 13.9743 23.4321C14.6906 23.4341 15.4069 23.4349 16.1232 23.4348C16.5509 23.4347 16.9785 23.4352 17.4061 23.4368C17.8084 23.4382 18.2107 23.4382 18.613 23.4371C18.7604 23.437 18.9078 23.4373 19.0552 23.4382C19.2569 23.4394 19.4586 23.4387 19.6603 23.4375C19.7471 23.4387 19.7471 23.4387 19.8356 23.4399C20.3208 23.4338 20.7768 23.3033 21.142 22.9714C21.5738 22.5089 21.6222 22.0316 21.6186 21.4227C21.6188 21.3174 21.6188 21.3174 21.6191 21.2101C21.6195 20.9753 21.6189 20.7406 21.6182 20.5058C21.6183 20.3374 21.6185 20.169 21.6187 20.0006C21.619 19.5435 21.6185 19.0864 21.6177 18.6293C21.617 18.1515 21.6172 17.6737 21.6172 17.1958C21.6171 16.3938 21.6165 15.5918 21.6154 14.7897C21.6144 13.9639 21.6139 13.1381 21.6139 12.3123C21.6139 12.2614 21.6139 12.2105 21.6139 12.158C21.6139 12.0818 21.6139 12.0818 21.6139 12.004C21.614 11.1118 21.6136 10.2196 21.613 9.32736C21.6127 8.94707 21.6126 8.56677 21.6125 8.18648C21.6124 7.73938 21.612 7.29227 21.6112 6.84517C21.611 6.6806 21.6109 6.51603 21.611 6.35146C21.611 6.12785 21.6106 5.90424 21.61 5.68063C21.6102 5.58161 21.6102 5.58161 21.6104 5.4806C21.6376 5.19228 21.6376 5.19228 21.525 4.95046C21.4077 4.94282 21.2901 4.94028 21.1725 4.93982C21.0974 4.93929 21.0223 4.93876 20.9449 4.93822C20.8221 4.93775 20.8221 4.93775 20.6968 4.93727C20.5248 4.93553 20.3527 4.93372 20.1807 4.93185C19.9085 4.92922 19.6363 4.92702 19.3641 4.92601C19.102 4.92485 18.8401 4.92183 18.578 4.91852C18.4564 4.91874 18.4564 4.91874 18.3323 4.91896C17.8901 4.91179 17.5862 4.89524 17.25 4.57546C17.1275 4.32195 17.0806 4.11457 17.0761 3.8343C17.0739 3.72848 17.0739 3.72848 17.0716 3.62053C17.0703 3.50777 17.0703 3.50777 17.069 3.39274C17.0668 3.27618 17.0668 3.27618 17.0646 3.15725C17.0601 2.90968 17.0566 2.66211 17.0531 2.41452C17.0503 2.2464 17.0473 2.07829 17.0443 1.91017C17.0372 1.49861 17.0308 1.08704 17.025 0.675456C16.7025 0.553288 16.4363 0.506644 16.0921 0.506409C15.9965 0.505986 15.9008 0.505563 15.8022 0.505127C15.6971 0.505419 15.5921 0.505726 15.487 0.506047C15.3756 0.505844 15.2641 0.505577 15.1527 0.505251C14.8509 0.504568 14.549 0.504832 14.2472 0.505308C13.9307 0.505688 13.6143 0.505335 13.2979 0.5051C12.7664 0.504827 12.2349 0.505186 11.7034 0.505901C11.0899 0.506716 10.4763 0.506453 9.86273 0.505627C9.3352 0.504945 8.80767 0.504851 8.28014 0.505243C7.9654 0.505476 7.65067 0.505509 7.33593 0.505012C7.03982 0.504577 6.74373 0.504883 6.44762 0.505746C6.33927 0.505944 6.23091 0.505889 6.12256 0.505557C5.2425 0.503108 4.57699 0.523476 3.92345 1.17702ZM17.625 1.05046C17.6157 1.48288 17.6089 1.91525 17.6044 2.34776C17.6025 2.49486 17.6 2.64196 17.5967 2.78904C17.5922 3.00055 17.59 3.21196 17.5884 3.4235C17.5855 3.52207 17.5855 3.52207 17.5825 3.62263C17.5824 3.91944 17.5873 4.07462 17.7674 4.3175C18.1014 4.47253 18.3946 4.46277 18.7585 4.45475C18.8676 4.45412 18.8676 4.45412 18.9789 4.45347C19.2104 4.45179 19.4419 4.44803 19.6734 4.44421C19.8307 4.4427 19.988 4.44133 20.1453 4.4401C20.5302 4.4368 20.9151 4.43163 21.3 4.42546C20.9567 4.01662 20.9567 4.01662 20.5811 3.63796C20.5348 3.59496 20.4886 3.55197 20.441 3.50768C20.3696 3.44223 20.3696 3.44223 20.2969 3.37546C20.247 3.32926 20.1971 3.28307 20.1456 3.23547C19.8599 2.97181 19.5715 2.71173 19.2765 2.45846C18.9983 2.21422 18.7296 1.95937 18.4594 1.70641C18.2839 1.54719 18.1005 1.40392 17.9104 1.26258C17.8568 1.22268 17.8032 1.18277 17.748 1.14165C17.7074 1.11156 17.6668 1.08146 17.625 1.05046ZM2.63439 1.88014C2.55579 1.9441 2.55579 1.9441 2.4756 2.00934C2.08058 2.44509 2.06744 2.90329 2.07144 3.46334C2.07109 3.53906 2.07074 3.61479 2.07038 3.69281C2.06948 3.94597 2.07019 4.1991 2.0709 4.45226C2.07059 4.634 2.07019 4.81573 2.0697 4.99747C2.06878 5.43949 2.06892 5.88151 2.06957 6.32353C2.07008 6.68285 2.07015 7.04217 2.0699 7.40149C2.06987 7.45269 2.06983 7.50388 2.0698 7.55662C2.06973 7.66062 2.06965 7.76462 2.06958 7.86862C2.06894 8.84326 2.06968 9.81789 2.07088 10.7925C2.07189 11.6283 2.07172 12.4641 2.07068 13.3C2.06947 14.2712 2.069 15.2424 2.06969 16.2136C2.06976 16.3172 2.06983 16.4208 2.0699 16.5244C2.06994 16.5754 2.06997 16.6264 2.07001 16.6789C2.0702 17.0377 2.06988 17.3965 2.06935 17.7552C2.06865 18.2384 2.06915 18.7215 2.07045 19.2046C2.07074 19.3819 2.07066 19.5592 2.07016 19.7366C2.06955 19.9786 2.07032 20.2206 2.07144 20.4626C2.07094 20.5328 2.07044 20.603 2.06992 20.6753C2.07461 21.1971 2.15677 21.5563 2.50782 21.9614C2.70486 22.1429 2.70486 22.1429 3.00001 22.2755C3.00001 15.4692 3.00001 8.66296 3.00001 1.65046C2.85342 1.65046 2.74111 1.79121 2.63439 1.88014Z"
            fill="#1D3557"
          />
          <path
            d="M5.74399 2.31513C5.85552 2.31465 5.85552 2.31465 5.9693 2.31416C6.09267 2.31421 6.09267 2.31421 6.21854 2.31427C6.30463 2.31401 6.39071 2.31376 6.47941 2.3135C6.76561 2.31279 7.05179 2.31264 7.33799 2.31256C7.53594 2.31232 7.73389 2.31207 7.93185 2.31181C8.34741 2.31133 8.76298 2.31121 9.17855 2.31126C9.65941 2.31131 10.1403 2.31052 10.6211 2.30933C11.083 2.30823 11.545 2.30796 12.0069 2.30801C12.2037 2.30792 12.4006 2.30759 12.5974 2.30701C12.8722 2.30628 13.147 2.30649 13.4218 2.30694C13.5449 2.30631 13.5449 2.30631 13.6705 2.30566C13.7824 2.30614 13.7824 2.30614 13.8965 2.30662C13.9615 2.30658 14.0265 2.30654 14.0935 2.30649C14.25 2.32516 14.25 2.32516 14.4 2.47516C14.3583 2.81683 14.3583 2.81683 14.25 2.92516C14.1355 2.93267 14.0207 2.93497 13.906 2.93519C13.7945 2.93567 13.7945 2.93567 13.6807 2.93616C13.5985 2.93612 13.5162 2.93609 13.4315 2.93606C13.3454 2.93631 13.2593 2.93656 13.1706 2.93682C12.8844 2.93753 12.5982 2.93768 12.312 2.93776C12.1141 2.938 11.9161 2.93825 11.7182 2.93851C11.3026 2.93899 10.887 2.93911 10.4715 2.93906C9.9906 2.93901 9.50974 2.9398 9.02889 2.94099C8.56696 2.94209 8.10504 2.94236 7.64312 2.94231C7.44626 2.9424 7.24941 2.94273 7.05255 2.94331C6.77778 2.94404 6.50302 2.94383 6.22824 2.94338C6.14614 2.9438 6.06405 2.94422 5.97946 2.94466C5.9049 2.94434 5.83034 2.94403 5.75351 2.9437C5.68849 2.94374 5.62346 2.94378 5.55646 2.94383C5.4 2.92516 5.4 2.92516 5.25 2.77516C5.29954 2.36895 5.34511 2.3159 5.74399 2.31513Z"
            fill="#1D3557"
          />
          <path
            d="M15.7828 12.8857C16.05 12.8998 16.05 12.8998 16.2 13.0498C16.2188 13.3123 16.2188 13.3123 16.2 13.5748C16.05 13.7248 16.05 13.7248 15.8833 13.7819C15.6006 13.908 15.413 14.0972 15.1922 14.3107C15.1096 14.3895 15.0269 14.4681 14.9441 14.5466C14.9038 14.585 14.8635 14.6234 14.822 14.663C14.7027 14.7723 14.5794 14.8731 14.4528 14.9737C14.2711 15.1315 14.1899 15.2101 14.1141 15.4311C14.025 15.6748 14.025 15.6748 13.95 15.7498C13.5544 15.7842 13.5544 15.7842 13.3594 15.6607C13.2489 15.4828 13.2584 15.3554 13.275 15.1498C13.2333 15.1328 13.1915 15.1158 13.1485 15.0982C12.975 14.9998 12.975 14.9998 12.7969 14.8029C12.6167 14.6065 12.6167 14.6065 12.3827 14.594C12.0897 14.6328 12.0174 14.7143 11.8313 14.9389C11.7814 14.9972 11.7315 15.0555 11.6801 15.1155C11.5517 15.2975 11.473 15.4652 11.4 15.6748C10.92 15.7744 10.92 15.7744 10.7297 15.6701C10.6144 15.4598 10.6206 15.3107 10.65 15.0748C10.7391 14.9389 10.7391 14.9389 10.875 14.8498C10.9334 14.8429 10.9918 14.8361 11.052 14.829C11.3168 14.7565 11.3924 14.6367 11.5547 14.4186C11.6035 14.354 11.6524 14.2894 11.7027 14.2229C11.7513 14.1575 11.7999 14.0921 11.85 14.0248C11.9496 13.8995 12.0495 13.7743 12.15 13.6498C12.361 13.6639 12.361 13.6639 12.6 13.7248C12.6792 13.8472 12.7533 13.9729 12.825 14.0998C13.1224 14.403 13.3965 14.6321 13.8 14.7748C13.8682 14.7135 13.8682 14.7135 13.9377 14.6509C14.0006 14.5943 14.0634 14.5378 14.1282 14.4795C14.196 14.418 14.2639 14.3565 14.3338 14.2932C14.4748 14.1671 14.6173 14.0428 14.7616 13.9205C14.8279 13.8637 14.8942 13.8068 14.9625 13.7482C15.0236 13.6969 15.0847 13.6456 15.1477 13.5927C15.3255 13.3968 15.3794 13.2272 15.45 12.9748C15.525 12.8998 15.525 12.8998 15.7828 12.8857Z"
            fill="#1D3557"
          />
          <path
            d="M5.94346 6.66257C6.02517 6.6622 6.02517 6.6622 6.10853 6.66181C6.22397 6.66143 6.33941 6.66126 6.45485 6.66127C6.63181 6.66111 6.80874 6.65975 6.98569 6.65832C7.09766 6.6581 7.20962 6.65795 7.32158 6.65788C7.40127 6.65707 7.40127 6.65707 7.48258 6.65625C7.85784 6.65801 7.85784 6.65801 8.025 6.82517C7.98333 7.16683 7.98333 7.16683 7.875 7.27517C7.69313 7.28366 7.51348 7.28748 7.33154 7.28777C7.27707 7.28802 7.2226 7.28827 7.16647 7.28852C7.05103 7.2889 6.93559 7.28908 6.82015 7.28907C6.64319 7.28923 6.46626 7.29059 6.28931 7.29201C6.17734 7.29223 6.06538 7.29238 5.95342 7.29245C5.87373 7.29326 5.87373 7.29326 5.79242 7.29409C5.41716 7.29233 5.41716 7.29233 5.25 7.12517C5.31191 6.61754 5.48215 6.66329 5.94346 6.66257Z"
            fill="#1D3557"
          />
          <path
            d="M6.29531 11.6109C6.37957 11.61 6.46383 11.6091 6.55063 11.6081C6.67122 11.6079 6.67122 11.6079 6.79424 11.6077C6.90546 11.6072 6.90546 11.6072 7.01893 11.6068C7.2 11.625 7.2 11.625 7.35 11.775C7.30833 12.1166 7.30833 12.1166 7.2 12.225C6.90204 12.2439 6.60318 12.2389 6.30469 12.239C6.22043 12.24 6.13617 12.2409 6.04937 12.2418C5.96898 12.242 5.88859 12.2421 5.80576 12.2423C5.69454 12.2427 5.69454 12.2427 5.58107 12.2432C5.4 12.225 5.4 12.225 5.25 12.075C5.32708 11.4429 5.75222 11.6112 6.29531 11.6109Z"
            fill="#1D3557"
          />
          <path
            d="M6.29531 9.13631C6.37957 9.13539 6.46383 9.13447 6.55063 9.13352C6.67122 9.13331 6.67122 9.13331 6.79424 9.13308C6.90546 9.13262 6.90546 9.13262 7.01893 9.13215C7.2 9.15037 7.2 9.15037 7.35 9.30037C7.30833 9.64204 7.30833 9.64204 7.2 9.75037C6.90204 9.76931 6.60318 9.76426 6.30469 9.76443C6.22043 9.76535 6.13617 9.76627 6.04937 9.76721C5.96898 9.76736 5.88859 9.7675 5.80576 9.76765C5.69454 9.76812 5.69454 9.76812 5.58107 9.76859C5.4 9.75037 5.4 9.75037 5.25 9.60037C5.32708 8.96833 5.75222 9.13662 6.29531 9.13631Z"
            fill="#1D3557"
          />
        </g>
        <defs>
          <clipPath id="clip0_4592_185992">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    key: 'ai_keyword_research_tools',
    isSection: false,
    isTools: true,
    isSubscriberUserShow: true,
    uniqueKey: 'AI Keyword Research Tools',
    parentSectionKey: 'all_tools',
    subNavs: [
      {
        title: 'Keyword Research Tool',
        parentTitle: 'AI Keyword Research Tools',
        uniqueKey: 'keyword_research_tool',
        icon: <TrendingUp />,
        to: '/free-tools/keyword-research',
        isShow: true,
      },
      {
        title: 'Keyword Statistics',
        parentTitle: 'AI Keyword Research Tools',
        uniqueKey: 'keyword_statistics',
        icon: <TrendingUp />,
        to: '/free-tools/keyword-statistics',
        isShow: true,
      },
      {
        title: 'Cluster Keywords',
        parentTitle: 'AI Keyword Research Tools',
        uniqueKey: 'cluster_keywords',
        icon: <TrendingUp />,
        to: '/free-tools/keyword-clustering',
        isShow: true,
      },
    ],
  },
];

export const contentAiNavConfig: SidebarNav[] = [
  {
    title: 'Home',
    icon: <Home />,
    iconLarge: <Home />,
    key: 'home-content-ai',
    isSection: false,
    to: '/app/content-ai-home',
    isSubscriberUserShow: false,
    uniqueKey: 'home',
    IsPlaneNav: true,
  },
  {
    title: 'Content AI',
    isDynamicNav: false,
    isSection: true,
    isSubscriberUserShow: true,
    key: 'content-ai',
    uniqueKey: 'content-ai',
    subNavs: [],
  },
  {
    title: 'Plan Keywords',
    icon: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="ContentPasteSearchOutlinedIcon"
      >
        <path d="M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"></path>
        <path d="M20.3 18.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S12 14 12 16.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l2.7 2.7 1.4-1.4-2.7-2.7zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"></path>
      </svg>
    ),
    iconLarge: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="ContentPasteSearchOutlinedIcon"
      >
        <path d="M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"></path>
        <path d="M20.3 18.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S12 14 12 16.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l2.7 2.7 1.4-1.4-2.7-2.7zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"></path>
      </svg>
    ),
    key: 'research-keywords',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'research-keywords',
    parentSectionKey: 'content-ai',
    subNavs: [
      {
        title: 'Keyword Lists',
        display: true,
        parentTitle: 'Plan Keywords',
        icon: <Settings />,
        to: '/app/manage-lists/keywords-list',
        uniqueKey: 'research-keywords-keyword-list',
      },
    ],
  },
  {
    title: 'Create Content',
    isDynamicNav: false,
    icon: (
      <svg
        className="magic-icon MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="AutoFixHighIcon"
      >
        <path d="M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41l-2.33-2.35zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"></path>
      </svg>
    ),
    iconLarge: (
      <svg
        className="magic-icon MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="AutoFixHighIcon"
      >
        <path d="M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41l-2.33-2.35zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"></path>
      </svg>
    ),
    key: 'content-brief',
    isSection: false,
    uniqueKey: 'create-content',
    isSubscriberUserShow: true,
    parentSectionKey: 'content-ai',
    subNavs: [
      // {
      //   title: 'Content Editor',
      //   parentTitle: 'Create Content',
      //   icon: <Description />,
      //   to: '/app/content-recommendations/editor',
      // },
      {
        title: 'Page Drafts',
        parentTitle: 'Create Content',
        icon: (
          <svg
            className="magic-icon MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            data-testid="AutoFixHighIcon"
          >
            <path d="M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41l-2.33-2.35zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"></path>
          </svg>
        ),
        iconLarge: (
          <svg
            className="magic-icon MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            data-testid="AutoFixHighIcon"
          >
            <path d="M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41l-2.33-2.35zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"></path>
          </svg>
        ),
        to: '/app/content-recommendations/content-brief',
        customComponent: <CreateContentBrief />,
        uniqueKey: 'create-content-page-drafts',
      },
    ],
  },
  {
    title: 'Optimize Content',
    isDynamicNav: false,
    icon: <img src={optimizeContent.src} alt="Optimize Content" />,
    iconLarge: <img src={optimizeContentLarge.src} alt="Optimize Content" />,
    key: 'content-recommendations',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'optimize-content',
    parentSectionKey: 'content-ai',
    subNavs: [
      {
        title: 'Organic Content',
        parentTitle: 'Optimize Content',
        icon: <img src={optimizeContent.src} alt="Organic Content" />,
        iconLarge: <img src={optimizeContentLarge.src} alt="Organic Content" />,
        to: '/app/content-recommendations?type=organic',
        showCreateNewUrlButton: true,
        uniqueKey: 'optimize-content-organic-content',
      },
      // {
      //   title: 'Paid Content',
      //   parentTitle: 'Optimize Content',
      //   icon: <img src={optimizeContent.src} alt="Paid Content" />,
      //   iconLarge: <img src={optimizeContentLarge.src} alt="Paid Content" />,
      //   to: '/app/content-recommendations?type=paid',
      //   uniqueKey: 'optimize-content-paid-content',
      // },
    ],
  },
  {
    title: 'Settings',
    isDynamicNav: true,
    icon: <Settings />,
    key: 'settings',
    isSection: false,
    display: false,
    uniqueKey: 'settings-settings',
    parentSectionKey: 'settings',
    subNavs: [
      {
        title: 'Connections',
        display: false,
        parentTitle: 'Settings',
        icon: <Settings />,
        to: '/app/settings/connections',
        uniqueKey: 'settings-connections',
      },
      {
        title: 'Setup',
        display: true,
        parentTitle: 'Settings',
        icon: <Settings />,
        to: '/app/settings/setup',
        uniqueKey: 'settings-setup',
      },
      // { title: 'Account Settings', parentTitle: 'Settings', icon: <Settings />, to: '/app/settings/account-settings' },
    ],
  },
  {
    title: 'Admin',
    isDynamicNav: true,
    icon: <SupervisorAccount />,
    key: 'admin',
    isInternal: true,
    isSection: false,
    display: false,
    uniqueKey: 'admin-admin',
    parentSectionKey: 'admin',
    subNavs: [
      {
        title: 'Tenants',
        display: true,
        parentTitle: 'Settings',
        icon: <Settings />,
        to: '/app/settings/admin/schema',
        uniqueKey: 'admin-schema',
        isInternal: true,
      },
    ],
  },
];

export const sidebarDefaultAiSeoNavs: SidebarNav[] = [
  {
    title: 'Analytics & Reporting',
    isDynamicNav: false,
    isSection: true,
    isSubscriberUserShow: true,
    key: 'analytics-reporting',
    uniqueKey: 'analytics-reporting',
    subNavs: [],
  },
  {
    title: 'Trends',
    icon: <TrendingUp />,
    key: 'trends',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'trends',
    parentSectionKey: 'analytics-reporting',
    subNavs: [
      {
        title: 'Growth Trends',
        parentTitle: 'Trends',
        uniqueKey: 'trends-growth-trends',
        icon: <TrendingUp />,
        to: '/app/trends/growth-trends',
        isShow: true,
      },
      {
        title: 'Competitive Trends',
        parentTitle: 'Trends',
        icon: <TrendingUp />,
        to: '/app/trends/competitive-trends',
        uniqueKey: 'trends-competitive-trends',
      },
      {
        title: 'Trends Watchlist',
        parentTitle: 'Trends',
        uniqueKey: 'trends-competitive-trends',
        icon: <TrendingUp />,
        to: '/app/trends/trend-watchlist',
        isShow: true,
      },
    ],
  },
  {
    title: 'Ranking Factors',
    icon: <img src={RankingFactorIcon.src} alt="Ranking Factors Icon" />,
    iconLarge: <img src={RankingFactorLargeIcon.src} alt="Ranking Factors Icon" />,
    key: 'ranking-factors',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'ranking-factors',
    parentSectionKey: 'analytics-reporting',
    subNavs: [
      {
        title: 'Ranking Factors Summary',
        parentTitle: 'Ranking Factors',
        icon: <img src={RankingFactorIcon.src} alt="Ranking Factors Icon" />,
        iconLarge: <img src={RankingFactorLargeIcon.src} alt="Ranking Factors Icon" />,
        to: '/app/ranking-factors/ranking-factors-summary',
        uniqueKey: 'ranking-factors-ranking-factors-summary',
      },
    ],
  },
  {
    title: 'Strategy Planning',
    icon: <BubbleChart />,
    key: 'opportunities',
    isSection: false,
    isSubscriberUserShow: false,
    uniqueKey: 'strategy-planning',
    parentSectionKey: 'analytics-reporting',
    subNavs: [
      {
        title: 'Opportunity Explorer',
        parentTitle: 'Strategy Planning',
        icon: <BubbleChart />,
        to: '/app/opportunities/opportunity-explorer',
        uniqueKey: 'strategy-planning-opportunity-explorer',
      },
      {
        title: 'Top Opportunities',
        parentTitle: 'Strategy Planning',
        icon: <BubbleChart />,
        to: '/app/opportunities/top-opportunities',
        uniqueKey: 'strategy-planning-top-opportunities',
      },
    ],
  },
  {
    title: 'Ad-Hoc Analysis',
    icon: <BarChart />,
    key: 'adhoc-analysis',
    isSection: false,
    isSubscriberUserShow: false,
    uniqueKey: 'adhoc-analysis',
    parentSectionKey: 'analytics-reporting',
    subNavs: [
      {
        title: 'All Boards',
        parentTitle: 'Ad-Hoc Analysis',
        uniqueKey: 'adhoc-analysis-all-boards',
        icon: <BarChart />,
        to: '/app/adhoc-analysis/all-boards',
      },
      {
        title: 'My Analysis',
        parentTitle: 'Ad-Hoc Analysis',
        icon: <BarChart />,
        to: '/app/adhoc-analysis/my-analysis',
        uniqueKey: 'adhoc-analysis-my-analysis',
      },
      {
        title: 'Favorites',
        parentTitle: 'Ad-Hoc Analysis',
        uniqueKey: 'adhoc-analysis-favorites',
        icon: <BarChart />,
        to: '/app/adhoc-analysis/favorites',
      },
    ],
  },
  {
    title: 'Automated SEO',
    isDynamicNav: false,
    isSection: true,
    key: 'technical-seo',
    isSubscriberUserShow: true,
    uniqueKey: 'technical-seo',
    subNavs: [],
  },
  {
    title: 'Technical Recommendations',
    icon: <Timelapse />,
    key: 'usability-recommendations',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'technical-recommendations',
    parentSectionKey: 'technical-seo',
    subNavs: [
      {
        title: 'Performance',
        parentTitle: 'Technical Recommendations',
        icon: <Timelapse />,
        to: '/app/usability-recommendations?type=performance',
        uniqueKey: 'technical-recommendations-performance',
      },
      {
        title: 'Accessibility',
        parentTitle: 'Technical Recommendations',
        icon: <Timelapse />,
        to: '/app/usability-recommendations?type=accessibility',
        uniqueKey: 'technical-recommendations-accessibility',
      },
      {
        title: 'Best Practices',
        parentTitle: 'Technical Recommendations',
        icon: <Timelapse />,
        to: '/app/usability-recommendations?type=best-practices',
        uniqueKey: 'technical-recommendations-best-practices',
      },
      {
        title: 'SEO Compliance',
        parentTitle: 'Technical Recommendations',
        icon: <Timelapse />,
        to: '/app/usability-recommendations?type=seo-compliance',
        uniqueKey: 'technical-recommendations-seo-compliance',
      },
      {
        title: 'Mobile Friendly',
        parentTitle: 'Technical Recommendations',
        icon: <Timelapse />,
        to: '/app/usability-recommendations?type=mobile',
        uniqueKey: 'technical-recommendations-mobile-friendly',
      },
    ],
  },
  {
    title: 'Internal Linking AI',
    icon: <img src={InternalLinkingAI.src} alt="Paid Content" />,
    iconLarge: <img src={InternalLinkingAILarge.src} alt="Paid Content" />,
    key: 'discoverability',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'internal-linking-ai',
    isInternal: true,
    parentSectionKey: 'technical-seo',
    subNavs: [
      {
        title: 'Bulk Internal Linking',
        parentTitle: 'Internal Linking AI',
        icon: <img src={InternalLinkingAI.src} alt="Paid Content" />,
        iconLarge: <img src={InternalLinkingAILarge.src} alt="Paid Content" />,
        to: '/app/discoverability/internal-linking-recommendations',
        uniqueKey: 'internal-linking-ai-linking-modules',
        customComponent: <AddNewLink />,
      },
      {
        title: 'Autonomous Internal Linking',
        parentTitle: 'Internal Linking AI',
        icon: <img src={InternalLinkingAI.src} alt="Paid Content" />,
        iconLarge: <img src={InternalLinkingAILarge.src} alt="Paid Content" />,
        to: '/app/discoverability/autonomous-internal-linking',
        uniqueKey: 'il-autonomous',
        customComponent: <AddNewLink isNewInternalLinking={true} />,
        showNewBadge: true,
      },
    ],
  },
  {
    title: 'Taxonomy',
    isDynamicNav: false,
    isSection: true,
    key: 'taxonomy',
    isSubscriberUserShow: true,
    uniqueKey: 'taxonomy',
    subNavs: [],
  },
  {
    title: 'Manage Queries',
    icon: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="NotesOutlinedIcon"
      >
        <path d="M21 11.01 3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"></path>
      </svg>
    ),
    iconLarge: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="NotesOutlinedIcon"
      >
        <path d="M21 11.01 3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"></path>
      </svg>
    ),
    key: 'manage-queries',
    isSection: false,
    isSubscriberUserShow: false,
    uniqueKey: 'manage-queries',
    parentSectionKey: 'taxonomy',
    subNavs: [
      {
        title: 'View Search Intents',
        display: true,
        parentTitle: 'Manage Queries',
        icon: <Settings />,
        to: '/app/manage-queries/intent-settings/all-search-intent',
        uniqueKey: 'manage-queries-view-search-intents',
      },
      {
        title: 'Setup Search Intents',
        display: true,
        parentTitle: 'Manage Queries',
        icon: <Settings />,
        to: '/app/manage-queries/intent-settings/classify-keywords',
        uniqueKey: 'manage-queries-setup-search-intents',
      },
    ],
  },
  {
    title: 'Manage Categories',
    icon: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="LinkOutlinedIcon"
      >
        <path d="M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"></path>
      </svg>
    ),
    iconLarge: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="LinkOutlinedIcon"
      >
        <path d="M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"></path>
      </svg>
    ),
    key: 'manage-category',
    isSection: false,
    isSubscriberUserShow: false,
    uniqueKey: 'manage-category',
    parentSectionKey: 'taxonomy',
    subNavs: [
      {
        title: 'Category Setup',
        display: true,
        parentTitle: 'Manage Categories',
        icon: <Settings />,
        to: '/app/manage-categories/all-categories',
        uniqueKey: 'manage-category-category-setup',
      },
    ],
  },
  {
    title: 'Manage Lists',
    icon: <img src={manageEntities.src} alt="Manage Lists" />,
    iconLarge: <img src={manageEntities.src} alt="Manage Lists" />,
    key: 'manage-list',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'manage-list',
    parentSectionKey: 'taxonomy',
    subNavs: [
      {
        title: 'Entity Lists',
        display: true,
        parentTitle: 'Manage Lists',
        icon: <Settings />,
        to: '/app/manage-lists/entity-list',
        uniqueKey: 'manage-list-entity-list',
      },
      {
        title: 'URL Lists',
        display: true,
        parentTitle: 'Manage Lists',
        icon: <Settings />,
        to: '/app/manage-lists/url-list',
        uniqueKey: 'manage-list-url-list',
      },
    ],
  },
];

export const sideBarNavs: SidebarNav[] = [
  {
    title: 'Analytics & Reporting',
    isDynamicNav: false,
    isSection: true,
    isSubscriberUserShow: true,
    key: 'analytics-reporting',
    uniqueKey: 'analytics-reporting',
    subNavs: [],
  },
  {
    title: 'Trends',
    icon: <TrendingUp />,
    key: 'trends',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'trends',
    parentSectionKey: 'analytics-reporting',
    subNavs: [
      {
        title: 'Growth Trends',
        parentTitle: 'Trends',
        uniqueKey: 'trends-growth-trends',
        icon: <TrendingUp />,
        to: '/app/trends/growth-trends',
        isShow: true,
      },
      {
        title: 'Competitive Trends',
        parentTitle: 'Trends',
        icon: <TrendingUp />,
        to: '/app/trends/competitive-trends',
        uniqueKey: 'trends-competitive-trends',
      },
      {
        title: 'Trends Watchlist',
        parentTitle: 'Trends',
        uniqueKey: 'trends-competitive-trends',
        icon: <TrendingUp />,
        to: '/app/trends/trend-watchlist',
        isShow: true,
      },
    ],
  },
  {
    title: 'Ranking Factors',
    icon: <img src={RankingFactorIcon.src} alt="Ranking Factors Icon" />,
    iconLarge: <img src={RankingFactorLargeIcon.src} alt="Ranking Factors Icon" />,
    key: 'ranking-factors',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'ranking-factors',
    parentSectionKey: 'analytics-reporting',
    subNavs: [
      {
        title: 'Ranking Factors Summary',
        parentTitle: 'Ranking Factors',
        icon: <img src={RankingFactorIcon.src} alt="Ranking Factors Icon" />,
        iconLarge: <img src={RankingFactorLargeIcon.src} alt="Ranking Factors Icon" />,
        to: '/app/ranking-factors/ranking-factors-summary',
        uniqueKey: 'ranking-factors-ranking-factors-summary',
      },
    ],
  },
  {
    title: 'Strategy Planning',
    icon: <BubbleChart />,
    key: 'opportunities',
    isSection: false,
    isSubscriberUserShow: false,
    uniqueKey: 'strategy-planning',
    parentSectionKey: 'analytics-reporting',
    subNavs: [
      {
        title: 'Opportunity Explorer',
        parentTitle: 'Strategy Planning',
        icon: <BubbleChart />,
        to: '/app/opportunities/opportunity-explorer',
        uniqueKey: 'strategy-planning-opportunity-explorer',
      },
      {
        title: 'Top Opportunities',
        parentTitle: 'Strategy Planning',
        icon: <BubbleChart />,
        to: '/app/opportunities/top-opportunities',
        uniqueKey: 'strategy-planning-top-opportunities',
      },
    ],
  },
  {
    title: 'Ad-Hoc Analysis',
    icon: <BarChart />,
    key: 'adhoc-analysis',
    isSection: false,
    isSubscriberUserShow: false,
    uniqueKey: 'adhoc-analysis',
    parentSectionKey: 'analytics-reporting',
    subNavs: [
      {
        title: 'All Boards',
        parentTitle: 'Ad-Hoc Analysis',
        uniqueKey: 'adhoc-analysis-all-boards',
        icon: <BarChart />,
        to: '/app/adhoc-analysis/all-boards',
      },
      {
        title: 'My Analysis',
        parentTitle: 'Ad-Hoc Analysis',
        icon: <BarChart />,
        to: '/app/adhoc-analysis/my-analysis',
        uniqueKey: 'adhoc-analysis-my-analysis',
      },
      {
        title: 'Favorites',
        parentTitle: 'Ad-Hoc Analysis',
        uniqueKey: 'adhoc-analysis-favorites',
        icon: <BarChart />,
        to: '/app/adhoc-analysis/favorites',
      },
    ],
  },
  {
    title: 'Content AI',
    isDynamicNav: false,
    isSection: true,
    isSubscriberUserShow: true,
    key: 'content-ai',
    uniqueKey: 'content-ai',
    subNavs: [],
  },
  {
    title: 'Plan Keywords',
    icon: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="ContentPasteSearchOutlinedIcon"
      >
        <path d="M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"></path>
        <path d="M20.3 18.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S12 14 12 16.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l2.7 2.7 1.4-1.4-2.7-2.7zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"></path>
      </svg>
    ),
    iconLarge: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="ContentPasteSearchOutlinedIcon"
      >
        <path d="M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"></path>
        <path d="M20.3 18.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S12 14 12 16.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l2.7 2.7 1.4-1.4-2.7-2.7zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"></path>
      </svg>
    ),
    key: 'research-keywords',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'research-keywords',
    parentSectionKey: 'content-ai',
    subNavs: [
      {
        title: 'Keyword Lists',
        display: true,
        parentTitle: 'Plan Keywords',
        icon: <Settings />,
        to: '/app/manage-lists/keywords-list',
        uniqueKey: 'research-keywords-keyword-list',
      },
    ],
  },
  {
    title: 'Create Content',
    isDynamicNav: false,
    icon: (
      <svg
        className="magic-icon MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="AutoFixHighIcon"
      >
        <path d="M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41l-2.33-2.35zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"></path>
      </svg>
    ),
    iconLarge: (
      <svg
        className="magic-icon MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="AutoFixHighIcon"
      >
        <path d="M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41l-2.33-2.35zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"></path>
      </svg>
    ),
    key: 'content-brief',
    isSection: false,
    uniqueKey: 'create-content',
    isSubscriberUserShow: true,
    parentSectionKey: 'content-ai',
    subNavs: [
      // {
      //   title: 'Content Editor',
      //   parentTitle: 'Create Content',
      //   icon: <Description />,
      //   to: '/app/content-recommendations/editor',
      // },
      {
        title: 'Page Drafts',
        parentTitle: 'Create Content',
        icon: (
          <svg
            className="magic-icon MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            data-testid="AutoFixHighIcon"
          >
            <path d="M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41l-2.33-2.35zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"></path>
          </svg>
        ),
        iconLarge: (
          <svg
            className="magic-icon MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            data-testid="AutoFixHighIcon"
          >
            <path d="M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41l-2.33-2.35zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"></path>
          </svg>
        ),
        to: '/app/content-recommendations/content-brief',
        customComponent: <CreateContentBrief />,
        uniqueKey: 'create-content-page-drafts',
      },
    ],
  },
  {
    title: 'Optimize Content',
    isDynamicNav: false,
    icon: <img src={optimizeContent.src} alt="Optimize Content" />,
    iconLarge: <img src={optimizeContentLarge.src} alt="Optimize Content" />,
    key: 'content-recommendations',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'optimize-content',
    parentSectionKey: 'content-ai',
    subNavs: [
      {
        title: 'Organic Content',
        parentTitle: 'Optimize Content',
        icon: <img src={optimizeContent.src} alt="Organic Content" />,
        iconLarge: <img src={optimizeContentLarge.src} alt="Organic Content" />,
        to: '/app/content-recommendations?type=organic',
        showCreateNewUrlButton: true,
        uniqueKey: 'optimize-content-organic-content',
      },
      {
        title: 'Paid Content',
        parentTitle: 'Optimize Content',
        icon: <img src={optimizeContent.src} alt="Paid Content" />,
        iconLarge: <img src={optimizeContentLarge.src} alt="Paid Content" />,
        to: '/app/content-recommendations?type=paid',
        uniqueKey: 'optimize-content-paid-content',
      },
    ],
  },
  {
    title: 'Automated SEO',
    isDynamicNav: false,
    isSection: true,
    key: 'technical-seo',
    isSubscriberUserShow: true,
    uniqueKey: 'technical-seo',
    subNavs: [],
  },
  {
    title: 'Technical Recommendations',
    icon: <Timelapse />,
    key: 'usability-recommendations',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'technical-recommendations',
    parentSectionKey: 'technical-seo',
    subNavs: [
      {
        title: 'Performance',
        parentTitle: 'Technical Recommendations',
        icon: <Timelapse />,
        to: '/app/usability-recommendations?type=performance',
        uniqueKey: 'technical-recommendations-performance',
      },
      {
        title: 'Accessibility',
        parentTitle: 'Technical Recommendations',
        icon: <Timelapse />,
        to: '/app/usability-recommendations?type=accessibility',
        uniqueKey: 'technical-recommendations-accessibility',
      },
      {
        title: 'Best Practices',
        parentTitle: 'Technical Recommendations',
        icon: <Timelapse />,
        to: '/app/usability-recommendations?type=best-practices',
        uniqueKey: 'technical-recommendations-best-practices',
      },
      {
        title: 'SEO Compliance',
        parentTitle: 'Technical Recommendations',
        icon: <Timelapse />,
        to: '/app/usability-recommendations?type=seo-compliance',
        uniqueKey: 'technical-recommendations-seo-compliance',
      },
      {
        title: 'Mobile Friendly',
        parentTitle: 'Technical Recommendations',
        icon: <Timelapse />,
        to: '/app/usability-recommendations?type=mobile',
        uniqueKey: 'technical-recommendations-mobile-friendly',
      },
    ],
  },
  {
    title: 'Internal Linking AI',
    icon: <img src={InternalLinkingAI.src} alt="Paid Content" />,
    iconLarge: <img src={InternalLinkingAILarge.src} alt="Paid Content" />,
    key: 'discoverability',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'internal-linking-ai',
    parentSectionKey: 'technical-seo',
    subNavs: [
      {
        title: 'Bulk Internal Linking',
        parentTitle: 'Internal Linking AI',
        icon: <img src={InternalLinkingAI.src} alt="Paid Content" />,
        iconLarge: <img src={InternalLinkingAILarge.src} alt="Paid Content" />,
        to: '/app/discoverability/internal-linking-recommendations',
        uniqueKey: 'internal-linking-ai-linking-modules',
        customComponent: <AddNewLink />,
      },
      {
        title: 'Autonomous Internal Linking',
        parentTitle: 'Internal Linking AI',
        icon: <img src={InternalLinkingAI.src} alt="Paid Content" />,
        iconLarge: <img src={InternalLinkingAILarge.src} alt="Paid Content" />,
        to: '/app/discoverability/autonomous-internal-linking',
        uniqueKey: 'il-autonomous',
        customComponent: <AddNewLink isNewInternalLinking={true} />,
        showNewBadge: true,
      },
    ],
  },
  {
    title: 'Taxonomy',
    isDynamicNav: false,
    isSection: true,
    key: 'taxonomy',
    isSubscriberUserShow: true,
    uniqueKey: 'taxonomy',
    subNavs: [],
  },
  {
    title: 'Manage Queries',
    icon: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="NotesOutlinedIcon"
      >
        <path d="M21 11.01 3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"></path>
      </svg>
    ),
    iconLarge: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="NotesOutlinedIcon"
      >
        <path d="M21 11.01 3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"></path>
      </svg>
    ),
    key: 'manage-queries',
    isSection: false,
    isSubscriberUserShow: false,
    uniqueKey: 'manage-queries',
    parentSectionKey: 'taxonomy',
    subNavs: [
      {
        title: 'View Search Intents',
        display: true,
        parentTitle: 'Manage Queries',
        icon: <Settings />,
        to: '/app/manage-queries/intent-settings/all-search-intent',
        uniqueKey: 'manage-queries-view-search-intents',
      },
      {
        title: 'Setup Search Intents',
        display: true,
        parentTitle: 'Manage Queries',
        icon: <Settings />,
        to: '/app/manage-queries/intent-settings/classify-keywords',
        uniqueKey: 'manage-queries-setup-search-intents',
      },
    ],
  },
  {
    title: 'Manage Categories',
    icon: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="LinkOutlinedIcon"
      >
        <path d="M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"></path>
      </svg>
    ),
    iconLarge: (
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        data-testid="LinkOutlinedIcon"
      >
        <path d="M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"></path>
      </svg>
    ),
    key: 'manage-category',
    isSection: false,
    isSubscriberUserShow: false,
    uniqueKey: 'manage-category',
    parentSectionKey: 'taxonomy',
    subNavs: [
      {
        title: 'Category Setup',
        display: true,
        parentTitle: 'Manage Categories',
        icon: <Settings />,
        to: '/app/manage-categories/all-categories',
        uniqueKey: 'manage-category-category-setup',
      },
    ],
  },
  {
    title: 'Manage Lists',
    icon: <img src={manageEntities.src} alt="Manage Lists" />,
    iconLarge: <img src={manageEntities.src} alt="Manage Lists" />,
    key: 'manage-list',
    isSection: false,
    isSubscriberUserShow: true,
    uniqueKey: 'manage-list',
    parentSectionKey: 'taxonomy',
    subNavs: [
      {
        title: 'Entity Lists',
        display: true,
        parentTitle: 'Manage Lists',
        icon: <Settings />,
        to: '/app/manage-lists/entity-list',
        uniqueKey: 'manage-list-entity-list',
      },
      {
        title: 'URL Lists',
        display: true,
        parentTitle: 'Manage Lists',
        icon: <Settings />,
        to: '/app/manage-lists/url-list',
        uniqueKey: 'manage-list-url-list',
      },
    ],
  },
  {
    title: 'Settings',
    isDynamicNav: true,
    icon: <Settings />,
    key: 'settings',
    isSection: false,
    display: false,
    uniqueKey: 'settings-settings',
    parentSectionKey: 'settings',
    subNavs: [
      {
        title: 'Connections',
        display: false,
        parentTitle: 'Settings',
        icon: <Settings />,
        to: '/app/settings/connections',
        uniqueKey: 'settings-connections',
      },
      {
        title: 'Setup',
        display: true,
        parentTitle: 'Settings',
        icon: <Settings />,
        to: '/app/settings/setup',
        uniqueKey: 'settings-setup',
      },
      // { title: 'Account Settings', parentTitle: 'Settings', icon: <Settings />, to: '/app/settings/account-settings' },
    ],
  },
  {
    title: 'Admin',
    isDynamicNav: true,
    icon: <SupervisorAccount />,
    key: 'admin',
    isInternal: true,
    isSection: false,
    display: false,
    uniqueKey: 'admin-admin',
    parentSectionKey: 'admin',
    subNavs: [
      {
        title: 'Tenants',
        display: true,
        parentTitle: 'Settings',
        icon: <Settings />,
        to: '/app/settings/admin/schema',
        uniqueKey: 'admin-schema',
        isInternal: true,
      },
    ],
  },
];

export const HelpCenterContentAI = {
  title: 'Help Center',
  isDynamicNav: true,
  icon: <img src={iconHelpCenter.src} alt="Help Center Icon" style={{ width: '15px' }} />,
  key: 'helpcenter',
  toExternal: 'https://help.quattr.com/en/',
  isSection: false,
  display: false,
  uniqueKey: 'helpcenter',
  parentSectionKey: 'helpcenter',
};

export const HomeNavForContentAI = {
  title: 'Home',
  icon: <Home />,
  iconLarge: <Home />,
  key: 'home',
  isSection: false,
  to: '/app/content-ai-home',
  isSubscriberUserShow: false,
  uniqueKey: 'home',
  IsPlaneNav: true,
  // subNavs: [
  //   {
  //     title: 'Home',
  //     display: true,
  //     parentTitle: 'home',
  //     icon: <Home />,
  //     to: '/app/content-ai-home',
  //     uniqueKey: 'content-ai-home',
  //   }]
  // parentSectionKey: 'analytics-reporting',
};
export const excludeSideBarMenuList = ['Organic Content', 'Page Drafts', 'Keyword Lists'];
export const excludeNavigateURLList = [
  '/app/content-recommendations',
  '/app/content-recommendations/details/[id]',
  '/app/content-recommendations/content-brief',
  '/app/content-recommendations/content-brief/details/[id]',
  '/app/manage-lists/keywords-list',
  '/app/manage-lists/keywords-list/create',
  '/app/manage-lists/keywords-list/edit',
  '/app/manage-lists/keywords-list/detail',
  '/app/settings/connections',
];
export const avoidSortNavigationUniqueId = [
  'trends',
  'trends-growth-trends',
  'trends-competitive-trends',
  'trends-trends-watchlist',
  'ranking-factors',
  'ranking-factors-ranking-factors-summary',
  'strategy-planning',
  'strategy-planning-opportunity-explorer',
  'strategy-planning-top-opportunities',
  'adhoc-analysis',
  'adhoc-analysis-all-boards',
  'adhoc-analysis-my-analysis',
  'adhoc-analysis-favorites',
];

export const sideBarSectionOrder = ['content-ai', 'create-content', 'optimize-content'];
export const excludeCustomerList = CONTENT_AI_ONLY_SCHEMAS;
export const featureFlagNavKeyMapping = {
  contentrecommendation: 'content-recommendations',
  intentmanagement: 'settings',
};

export const sidebarConfigAiToolsSpecificUsers = {
  'admin-schema': false,
  'adhoc-analysis': false,
  'adhoc-analysis-all-boards': false,
  'adhoc-analysis-favorites': false,
  'adhoc-analysis-my-analysis': false,
  'analytics-reporting': false,
  'content-ai': false,
  'create-content': false,
  'create-content-page-drafts': false,
  helpcenter: false,
  'internal-linking-ai': false,
  'internal-linking-ai-linking-modules': false,
  'il-autonomous': false,
  'is-content-enabled-only': false,
  'manage-category': false,
  'manage-category-category-setup': false,
  'manage-list': false,
  'manage-list-entity-list': false,
  'manage-list-url-list': false,
  'manage-queries': false,
  'manage-queries-setup-search-intents': false,
  'manage-queries-view-search-intents': false,
  'optimize-content': false,
  'optimize-content-organic-content': false,
  'optimize-content-paid-content': false,
  'ranking-factors': false,
  'ranking-factors-ranking-factors-summary': false,
  'research-keywords': false,
  'research-keywords-keyword-list': false,
  settings: false,
  'settings-connections': false,
  'settings-settings': false,
  'settings-setup': false,
  'strategy-planning': false,
  'strategy-planning-opportunity-explorer': false,
  'strategy-planning-top-opportunities': false,
  taxonomy: false,
  'technical-recommendations': false,
  'technical-recommendations-accessibility': false,
  'technical-recommendations-best-practices': false,
  'technical-recommendations-mobile-friendly': false,
  'technical-recommendations-performance': false,
  'technical-recommendations-seo-compliance': false,
  'technical-seo': false,
  trends: false,
  'trends-competitive-trends': false,
  'trends-growth-trends': false,
  'trends-trends-alerts': false,
  'trends-trends-watchlist': false,
};
